import {
  getAppCustomEnv,
  GetCompaniesByNameProxy,
  renderSnackbarMessage,
} from "@sleek/customer-common-acquisition";
import axios, { CancelToken } from "axios";
import vueStore from "@/store";
import { Subject, Observable } from "rxjs";
import get from "lodash/get";
import { debounceTime, distinctUntilChanged, switchMap } from "rxjs/operators";
import { growthbookUtil } from "@sleek/customer-common-acquisition";

import { evalCondition } from "@/modules/sleek-onboarding/utils/rule-evaluator.js";
import { OrderProxy } from "@/proxies/order/order.proxy";
import Cookies from "js-cookie";
import Vue from "vue";

const getCartObservableInput = new Subject();
getCartObservableInput
  .pipe(
    debounceTime(140),
    distinctUntilChanged(),
    switchMap((requestPayload) => {
      const { bundleId, onboardingData } = requestPayload;
      return cartRequestObservable(bundleId, onboardingData);
    })
    // catchError(() => Observable.of({}))
    // tap((res) => console.log("tap", res))
  )
  .subscribe(() => {});
const cartRequestObservable = (bundleId, onboardingData) =>
  Observable.create(function (observer) {
    const cancelSource = CancelToken.source();
    getAppCustomEnv()
      .then((appCustomEnv) => {
        const { VUE_APP_PLATFORM_ACQUISITION_API } = appCustomEnv;
        const endpointUrl = "bundle";
        vueStore.commit("onboardingFlowModule/setCartLoading", true);
        const usingAuditTaxPremium = growthbookUtil.getFeatureValue(
          "sa-35731_apply_audit_tax_premium"
        );
        return axios.post(
          `${VUE_APP_PLATFORM_ACQUISITION_API}/${endpointUrl}/${bundleId}`,
          onboardingData,
          {
            cancelToken: cancelSource.token,
            params: {
              usingAuditTaxPremium,
            },
          }
        );
      })
      .then(
        (result) => {
          const { data } = result;
          if (data) {
            vueStore.commit("onboardingFlowModule/setCartData", data);

            vueStore.commit(
              "onboardingFlowModule/setCouponArray",
              data.couponArray || []
            );
            vueStore.commit(
              "onboardingFlowModule/setCouponEligible",
              data.coupon
            );
            observer.next(data);
          }
          vueStore.commit("onboardingFlowModule/setCartLoading", false);
          observer.complete();
        },
        (err) => {
          if (axios.isCancel(err)) {
            observer.complete();
          } else {
            console.error("Error while gettingCart data", err);
            observer.error(err);
          }
        }
      );

    return () => cancelSource.cancel();
  });

const initialState = {
  // Form
  // Form--CompanyName
  companyName: "",
  desiredCompanyName: [],
  // Form--Nominee-Director
  hasNomineeDirector: false,
  nomineeDirectorTerm: 6,
  // Form--CorpSec
  numberOfShareholder: 1,
  needCorpSec: false,
  hasCorporateShareholder: false,
  // Form--Mailroom
  hasMailroom: true,
  // Form--Manage-Financial
  manageFinancial: "",
  financialNotSureOption: null,
  showAccountingUI: false,
  // Form--Accounting
  needAccounting: true,
  accountingSubscriptionType: "", // 2_500_expense_annual_filling_bookkeeping_plan or internalName
  accountingExpense: 2500, // Undefined = not selected , null = more than 75k
  accountingTier: "",
  accountingAddons: [],
  inputtedAverageMonthlyExpense: null, // For more than the selectable accounting monthly expenses
  // Form--Audit-and-Tax
  hasAuditAndTaxPlan: true,
  auditAndTaxExpense: 15000, // Default to lowest for HK since the value will solely depend on acounting expense
  hasComplexAssetsAudit: false,
  // Form--Immigration,
  needVisaConsultation: null,
  hasVisaSupport: null,
  numberOfLetterOfConsent: 0,
  numberOfApplicationPass: 0,
  // AU
  // Form--ASIC Compliance
  hasASICCompliance: true,
  // Form--ABN & Tax compliance
  hasABNTaxCompliance: true,
  // Form--Add Ons
  addOnsSelected: [],

  needAccountingRemediation: null,
  needCompanySecretaryRemediation: undefined,
  needAuditRemediation: undefined,
  reconfirmAccounting: undefined,
  selectedFinancialYears: [],
  numberOfRemediationYears: 0,
  numberOfRemediationCompanySecretary: 0,
  numberOfRemediationAudit: 0,
  // End of AU
  // End of form
  pageServices: [],
  flowServices: [],
  bundleId: null,
  name: "",
  currentPage: {},
  cartData: undefined,
  isCartLoading: false,
  paymentType: 1,
  isAllowSleekToStayInTouch: false,
  contactDetails: {},
  coupon: "",
  couponArray: [],
  companyCreatedId: null,
  invoice: {},
  checkoutItems: [],
  sbaIsInterested: true,
  // Save for later
  saveForLater: {},
  needGuidancePopup: false,
  isSetInitialValues: false,
  popupTimeout: "",
  showComparePlanPopup: false,
  // Entity Selection
  isDormantFlow: null,
  isSoleTraderFlow: null,
  currentFlowId: {
    AccountingTransfer: null,
    SoleTrader: null,
    TransferDormant: null,
  },
  currentFlowPayload: {
    AccountingTransfer: null,
    SoleTrader: null,
    TransferDormant: null,
  },
  // End Entity Selection
  accountingOptionDisable: false,
  corpsecPlan: "standard",
  collapsedColC: true,
  order: null,
  listRemoveProduct: [],
  listAddProduct: [],
  isFirstShowBanner: true,
  couponEligible: "",
  isBilledYearly: true,
  isCheckoutPage: false,
  suffix: "",
};

const getters = {
  // general
  getPageServices: (state) => state.pageServices,
  getFlowServices: (state) => state.flowServices,
  getBundleId: (state) => state.bundleId,
  getFlowName: (state) => state.name,
  getCurrentPage: (state) => state.currentPage,
  getCartData: (state) => state.cartData,
  isCartLoading: (state) => state.isCartLoading,
  getNextPage: (state) => {
    const currentPageIndex = state.pageServices.findIndex(
      (page) => page.route === state.currentPage.route
    );

    let jumpIndex = 1;
    let nextPage = state.pageServices[currentPageIndex + jumpIndex];

    if (!nextPage) {
      return null;
    }

    while (nextPage.skipCondition) {
      const result = evalCondition(state, nextPage.skipCondition);
      if (result) {
        jumpIndex++;
        const pageAfterSkip = state.pageServices[currentPageIndex + jumpIndex];
        if (pageAfterSkip) {
          nextPage = pageAfterSkip;
        } else {
          return null;
          // break;
        }
      } else {
        return nextPage;
      }
    }
    console.log("NEXTPAGE", nextPage);
    return nextPage;
  },
  getFirstPage: (state, getters) => {
    const firstPage = state.pageServices[0];
    if (
      firstPage.skipCondition &&
      evalCondition(state, firstPage.skipCondition)
    ) {
      return getters.getNextPage;
    }
    return firstPage;
  },
  getPreviousPage: (state) => {
    const currentPageIndex = state.pageServices.findIndex(
      (page) => page.route === state.currentPage.route
    );

    let jumpIndex = 1;
    let previousPage = state.pageServices[currentPageIndex - jumpIndex];

    if (!previousPage) {
      return null;
    }

    while (previousPage.skipCondition) {
      const result = evalCondition(state, previousPage.skipCondition);
      if (result) {
        jumpIndex++;
        const pageAfterSkip = state.pageServices[currentPageIndex - jumpIndex];

        if (pageAfterSkip) {
          previousPage = pageAfterSkip;
        } else {
          return null;
          // break;
        }
      } else {
        return previousPage;
      }
    }
    console.log("PREVIOUSPAGE", previousPage);
    return previousPage;
  },
  getCurrentPageIndex: (state) =>
    state.pageServices.findIndex(
      (page) => page.route === state.currentPage.route
    ),
  getSelectedServices: (state) => {
    if (!state.cartData) return [];
    const services = [
      ...(state.cartData.fulfilledServices || []),
      ...(state.cartData.purchasedFromPageServices || []),
      ...(state.cartData.addOnsResult || []),
    ].filter((x) => (x.optional ? x.selected : true));
    return services;
  },
  getIsCurrentPageValid: (state) => {
    if (!state.currentPage) return true;
    return true;
  },
  // company name
  getCompanyName: (state) => state.companyName,
  getDesiredCompanyName: (state) => state.desiredCompanyName,
  // nominee director
  getHasNomineeDirector: (state) => state.hasNomineeDirector,
  getNomineeDirectorTerm: (state) => state.nomineeDirectorTerm,
  // shareholder
  getNumberOfShareholder: (state) => state.numberOfShareholder,
  getNeedCorpSec: (state) => state.needCorpSec,
  getCorpsecPlan: (state) => state.corpsecPlan,
  getHasCorporateShareholder: (state) => state.hasCorporateShareholder,
  // mailroom
  getHasMailroom: (state) => state.hasMailroom,
  // manage financial
  getManageFinancial: (state) => state.manageFinancial,
  getFinancialNotSureOption: (state) => state.financialNotSureOption,
  getShowAccountingUI: (state) => state.showAccountingUI,
  // accounting
  getAccountingSubscriptionType: (state) => state.accountingSubscriptionType,
  getAccountingAddons: (state) => state.accountingAddons,
  getAccountingExpense: (state) => state.accountingExpense,
  getAccountingTier: (state) => state.accountingTier,
  getNeedAccounting: (state) => state.needAccounting,
  getInputtedAverageMonthlyExpense: (state) =>
    state.inputtedAverageMonthlyExpense,
  // audit and tax
  getHasAuditAndTaxPlan: (state) => state.hasAuditAndTaxPlan,
  getHasComplexAssetsAudit: (state) => state.hasComplexAssetsAudit,
  getAuditAndTaxExpense: (state) => state.auditAndTaxExpense,
  // immigration
  getNeedVisaConsultation: (state) => state.needVisaConsultation,
  getHasVisaSupport: (state) => state.hasVisaSupport,
  getNumberOfLetterOfConsent: (state) => state.numberOfLetterOfConsent,
  getNumberOfApplicationPass: (state) => state.numberOfApplicationPass,
  // au
  // asic compliance
  getHasASICCompliance: (state) => state.hasASICCompliance,
  // abn & tax
  getHasABNTaxCompliance: (state) => state.hasABNTaxCompliance,
  // add ons
  getAddOnsSelected: (state) => state.addOnsSelected,
  // payment
  getPaymentType: (state) => state.paymentType,
  getIsAllowSleekToStayInTouch: (state) => state.isAllowSleekToStayInTouch,
  getContactDetails: (state) => state.contactDetails,
  getCoupon: (state) => state.coupon,
  getCouponArray: (state) => state.couponArray,
  getCompanyCreatedId: (state) => state.companyCreatedId,
  getInvoice: (state) => state.invoice,
  // checkout
  getCheckoutItems: (state) => state.checkoutItems,
  // save for later
  getSaveForLater: (state) => state.saveForLater,
  isAccountingFormValid: (state) => {
    console.log("isAccountingFormValid", state);
    const pageServices = state.pageServices;
    const accountingPageService = pageServices.find((service) => {
      return service.route?.includes("service-accounting");
    });
    if (!accountingPageService) return true;

    //for checkout page
    if (accountingPageService.route !== state.currentPage.route) return true;

    // for accounting logic page
    if (typeof state.accountingExpense === "undefined") return false;
    if (state.needAccounting === false) return false;
    if (state.accountingExpense === null) {
      if (!state.inputtedAverageMonthlyExpense) return false;
      if (Number.isNaN(state.inputtedAverageMonthlyExpense)) return false;

      const { uiConfiguration } = accountingPageService;
      const maximumSelectableExpense = get(
        uiConfiguration,
        "maximumSelectableExpense",
        75000
      );

      return (
        Number(state.inputtedAverageMonthlyExpense) > maximumSelectableExpense
      );
    }
    return !!state.accountingTier;
  },
  getSBAIsInterested: (state) => state.sbaIsInterested,
  getNeedGuidancePopup: (state) => state.needGuidancePopup,
  getPopupTimeout: (state) => state.popupTimeout,
  setIsSetInitialValues: (state) => state.isSetInitialValues,
  getCurrentState: (state) => state,
  getShowComparePlanPopup: (state) => state.showComparePlanPopup,
  getIsDormantFlow: (state) => state.isDormantFlow,
  getIsSoleTraderFlow: (state) => state.isSoleTraderFlow,
  getCurrentFlowId: (state) => state.currentFlowId,
  getAccountingOptionDisable: (state) => state.accountingOptionDisable,
  isTransfer: () => {
    // Return false for other countries
    return false;
  },
  getCollapsedColC: (state) => state.collapsedColC,
  getNeedAccountingRemediation: (state) => state.needAccountingRemediation,
  getNeedCompanySecretaryRemediation: (state) =>
    state.needCompanySecretaryRemediation,
  getSelectedFinancialYears: (state) => state.selectedFinancialYears,
  getNumberOfRemediationYears: (state) => state.numberOfRemediationYears,
  getListRemoveProduct: (state) => state.listRemoveProduct,
  getListAddProduct: (state) => state.listAddProduct,
  getNumberOfRemediationCompanySecretary: (state) =>
    state.numberOfRemediationCompanySecretary,
  getNeedAuditRemediation: (state) => state.needAuditRemediation,
  getNumberOfRemediationAudit: (state) => state.numberOfRemediationAudit,
  getReconfirmAccounting: (state) => state.reconfirmAccounting,
  getStateByName: (state) => (name) => state[name],
  getIsFirstShowBanner: (state) => state.isFirstShowBanner,
  getCouponEligible: (state) => state.couponEligible,
  getIsBilledYearly: (state) => state.isBilledYearly,
  getSuffix: (state) => state.suffix,
  getOrder: (state) => state.order,
  getIsCheckoutPage: (state) => state.isCheckoutPage,
};

const validateCompanyName = async (state, payload) => {
  try {
    const getCompaniesByNameProxy = new GetCompaniesByNameProxy();
    const { isExisting } = await getCompaniesByNameProxy.validateCompanyName({
      name: `${payload.companyName} ${payload.companyPrefix}` || "",
    });

    return isExisting;
  } catch (error) {
    // Todo setup general.messages.errors
    renderSnackbarMessage(
      state.platformConfig.general.messages.errors.GENERAL,
      6000
    );
  }
};

const getCartPayload = (state) => {
  const {
    numberOfShareholder,
    needCorpSec,
    hasCorporateShareholder,
    hasMailroom,
    accountingSubscriptionType,
    accountingAddons,
    coupon,
    accountingExpense,
    accountingTier,
    needAccounting,
    inputtedAverageMonthlyExpense,
    hasAuditAndTaxPlan,
    hasComplexAssetsAudit,
    auditAndTaxExpense,
    hasNomineeDirector,
    nomineeDirectorTerm,
    needVisaConsultation,
    hasVisaSupport,
    numberOfLetterOfConsent,
    numberOfApplicationPass,
    sbaIsInterested,
    hasASICCompliance,
    hasABNTaxCompliance,
    addOnsSelected,
    corpsecPlan,
    needAccountingRemediation,
    selectedFinancialYears,
    numberOfRemediationYears,
    listRemoveProduct,
    listAddProduct,
    needCompanySecretaryRemediation,
    numberOfRemediationCompanySecretary,
    needAuditRemediation,
    numberOfRemediationAudit,
    reconfirmAccounting,
    isBilledYearly,
    isCheckoutPage,
  } = state;

  return {
    numberOfShareholder,
    needCorpSec,
    hasCorporateShareholder,
    hasMailroom,
    accountingSubscriptionType,
    accountingAddons,
    accountingExpense,
    accountingTier,
    coupon,
    needAccounting,
    inputtedAverageMonthlyExpense,
    hasAuditAndTaxPlan,
    hasComplexAssetsAudit,
    auditAndTaxExpense,
    hasNomineeDirector,
    nomineeDirectorTerm,
    needVisaConsultation,
    hasVisaSupport,
    numberOfLetterOfConsent,
    numberOfApplicationPass,
    sbaIsInterested,
    hasASICCompliance,
    hasABNTaxCompliance,
    addOnsSelected,
    corpsecPlan,
    needAccountingRemediation,
    selectedFinancialYears,
    numberOfRemediationYears,
    listRemoveProduct,
    listAddProduct,
    needCompanySecretaryRemediation,
    numberOfRemediationCompanySecretary,
    needAuditRemediation,
    numberOfRemediationAudit,
    reconfirmAccounting,
    isBilledYearly,
    isCheckoutPage,
  };
};

const actions = {
  async getCartDataFromApi({ state }) {
    const { bundleId } = state;

    if (!bundleId) return;

    const onboardingData = getCartPayload(state);
    getCartObservableInput.next({
      bundleId,
      onboardingData,
    });
  },
  async processBeforePaymentAction({ state }) {
    const {
      companyName,
      suffix,
      contactDetails,
      checkoutItems,
      order,
      ownAddress,
      packageType,
    } = state;
    const data = {
      ...order,
      companyName:
        companyName && companyName.length
          ? companyName
          : `Draft Company ${new Date().toDateString()}`,
      companyNameSuffix: suffix,
      userContactInfo: contactDetails,
      checkoutItems,
      ownAddress,
      packageType,
      orderId: order._id,
    };
    const proxy = new OrderProxy();
    await proxy.processBeforePayment(data);
  },
  async updateOrderAction({ state, dispatch }) {
    const proxy = new OrderProxy();
    const {
      companyName,
      suffix,
      contactDetails,
      checkoutItems,
      order,
      ownAddress,
      packageType,
    } = state;
    const data = {
      ...order,
      companyName:
        companyName && companyName.length
          ? companyName
          : `Draft Company ${new Date().toDateString()}`,
      companyNameSuffix: suffix,
      userContactInfo: contactDetails,
      checkoutItems,
      ownAddress,
      packageType,
    };
    const response =
      order && order._id
        ? await proxy.updateOrder(order._id, data)
        : await proxy.createOrder(data);
    if (response) {
      dispatch("setOrderAction", response.data);
      Cookies.set("orderId", response.data._id, {
        expires: 7,
        sameSite: "strict",
        secure: true,
      });
    }
  },
  setOrderAction({ commit }, payload) {
    commit("setOrder", payload);
    commit("setCompanyName", payload.companyName);
    commit("setSuffix", payload.companyNameSuffix);
    commit("setContactDetails", payload.userContactInfo);
  },
  async onCheckCompanyName({ state }, payload) {
    if (payload) {
      const companyNameExist = await validateCompanyName(state, payload);
      return companyNameExist;
    }
  },
  setPaymentTypeAction({ commit }, payload) {
    commit("setPaymentType", payload);
  },
  setAllowSleekToStayInTouchAction({ commit }, payload) {
    commit("setAllowSleekToStayInTouch", payload);
  },
  setContactDetailsAction({ commit }, payload) {
    commit("setContactDetails", payload);
  },
  setCouponAction({ commit }, payload) {
    commit("setCoupon", payload);
  },
  setCouponArrayAction({ commit }, payload) {
    commit("setCouponArray", payload);
  },
  refetchCartData({ dispatch }) {
    dispatch("getCartDataFromApi");
  },
  // Corp Shareholder
  setNumberOfShareholder({ dispatch, commit }, payload) {
    commit("setNumberOfShareholder", payload);
    dispatch("getCartDataFromApi");
  },
  setNeedCorpSecAction({ dispatch, commit }, payload) {
    commit("setNeedCorpSec", payload);
    dispatch("getCartDataFromApi");
  },
  setCorpsecPlan({ dispatch, commit }, payload) {
    commit("setCorpsecPlan", payload);
    dispatch("getCartDataFromApi");
  },
  setHasCorporateShareholder({ dispatch, commit }, payload) {
    commit("setHasCorporateShareholder", payload);
    dispatch("getCartDataFromApi");
  },
  // Nominee Director
  setHasNomineeDirector({ dispatch, commit }, payload) {
    commit("setHasNomineeDirector", payload);
    dispatch("getCartDataFromApi");
  },
  setNomineeDirectorTermAction({ dispatch, commit }, payload) {
    commit("setNomineeDirectorTerm", payload);
    dispatch("getCartDataFromApi");
  },
  // Mailroom
  setHasMailroomAction({ dispatch, commit }, payload) {
    commit("setHasMailroom", payload);
    dispatch("getCartDataFromApi");
  },
  // For the past 2.5 years, nobody knows why we need this but it's here for now...
  // Or IIUC, this is to make the post-onboarding form actually works
  // Contract, ladies!
  setCompanyCreatedIdAction({ commit, state, getters }, companyId) {
    const orderId = state.order?._id ?? companyId;
    console.trace("setCompanyCreatedIdAction", orderId);
    localStorage.setItem(
      "isIncorporationActive",
      getters.isTransfer ? false : true
    );
    commit("setCompanyCreatedId", orderId);
    Cookies.set("createdCompanyId", orderId, { expires: 3 });
    localStorage.setItem("companyId", orderId);
  },
  setInvoiceAction({ commit }, payload) {
    commit("setInvoice", payload);
  },
  // TODO: Just set to initialState, it's fine
  clearOnboardingData({ commit }) {
    commit("resetState");
  },
  setCurrentPageAction({ commit, dispatch }, payload) {
    commit("setCurrentPage", payload.data);
    if (!payload.isEntityPage) {
      dispatch("getCartDataFromApi");
    }
  },
  // Accounting
  setAccountingAddonsAction({ commit, dispatch }, payload) {
    commit("setAccountingAddons", payload);
    dispatch("getCartDataFromApi");
  },
  setNeedAccounting({ commit, dispatch }, payload) {
    commit("setNeedAccounting", payload);
    dispatch("getCartDataFromApi");
  },
  setAccountingExpenseAction({ commit }, payload) {
    console.trace("setAccountingExpenseAction", payload);
    commit("setAccountingExpense", payload);
  },
  setAccountingTierAction({ commit }, payload) {
    commit("setAccountingTier", payload);
  },
  setInputtedAverageMonthlyExpenseAction({ commit }, payload) {
    commit("setInputtedAverageMonthlyExpense", payload);
  },
  setHasAuditAndTaxPlanAction({ commit }, payload) {
    commit("setHasAuditAndTaxPlan", payload);
  },
  setHasComplexAssetsAuditAction({ commit }, payload) {
    commit("setHasComplexAssetsAudit", payload);
  },
  setAuditAndTaxExpenseAction({ commit, dispatch }, payload) {
    commit("setAuditAndTaxExpense", payload);
    dispatch("getCartDataFromApi");
  },
  setCheckoutItemsAction({ commit }, payload) {
    commit("setCheckoutItems", payload);
  },
  setDesiredCompanyName({ commit }, payload) {
    commit("setDesiredCompanyName", payload);
  },
  setResumeOnboarding({ commit, dispatch }, payload) {
    commit("setResumeOnboarding", payload);
    dispatch("getCartDataFromApi");
  },

  //immigration
  setNeedVisaConsultation({ commit, dispatch }, payload) {
    commit("setNeedVisaConsultation", payload);
    dispatch("getCartDataFromApi");
  },
  setHasVisaSupport({ commit, dispatch }, payload) {
    commit("setHasVisaSupport", payload);
    dispatch("getCartDataFromApi");
  },
  setNumberOfLetterOfConsent({ commit, dispatch }, payload) {
    commit("setNumberOfLetterOfConsent", payload);
    dispatch("getCartDataFromApi");
  },
  setNumberOfApplicationPass({ commit, dispatch }, payload) {
    commit("setNumberOfApplicationPass", payload);
    dispatch("getCartDataFromApi");
  },

  // AU
  // ASIC Compliance
  setHasASICComplianceAction({ commit, dispatch }, payload) {
    commit("setHasASICCompliance", payload);
    dispatch("getCartDataFromApi");
  },
  // ABN & Tax compliance
  setHasABNTaxComplianceAction({ commit, dispatch }, payload) {
    commit("setHasABNTaxCompliance", payload);
    dispatch("getCartDataFromApi");
  },
  // ABN & Tax compliance
  setAddOnsSelectedAction({ commit, dispatch }, payload) {
    commit("setAddOnsSelected", payload);
    dispatch("getCartDataFromApi");
  },

  // Manage financial
  setManageFinancial({ commit }, payload) {
    commit("setManageFinancial", payload);
  },
  setFinancialNotSureOption({ commit }, payload) {
    commit("setFinancialNotSureOption", payload);
  },
  setShowAccountingUI({ commit }, payload) {
    commit("setShowAccountingUI", payload);
  },
  setPopupTimeout({ commit }, payload) {
    commit("setPopupTimeout", payload);
  },
  async setSBAIsInterested({ commit, dispatch }, payload) {
    commit("setSBAIsInterested", payload);
    dispatch("getCartDataFromApi");
  },
  setInitialValuesAction({ commit }, payload) {
    commit("setInitialValues", payload);
  },
  setShowComparePlanPopupAction({ commit }, payload) {
    commit("setShowComparePlanPopup", payload);
  },
  setIsDormantFlowAction({ commit }, payload) {
    commit("setIsDormantFlow", payload);
  },
  setIsSoleTraderFlowAction({ commit }, payload) {
    commit("setIsSoleTraderFlow", payload);
  },
  setCurrentBundleTransferIdAction({ commit }, payload) {
    commit("setCurrentBundleTransferId", payload);
  },
  setCurrentFlowPayloadAction({ commit, state }, payload) {
    const currentPayload = getCartPayload(state);
    commit("setCurrentFlowPayload", {
      flowName: payload,
      data: currentPayload,
    });
  },
  setAccountingOptionDisableAction({ commit }, payload) {
    commit("setAccountingOptionDisable", payload);
  },
  setCollapsedColCAction({ commit }, payload) {
    commit("setCollapsedColC", payload);
  },
  resetAUDataFlowAction({ commit }) {
    const data = {
      // Form--Accounting
      needAccounting: true,
      accountingSubscriptionType: "",
      accountingExpense: 2500,
      accountingTier: "accounting-annual-filling",
      accountingAddons: [],
      // Form--Mailroom
      hasMailroom: true,
      // Form--ASIC Compliance
      hasASICCompliance: true,
      // Form--ABN & Tax compliance
      hasABNTaxCompliance: true,
      // Form--Add Ons
      addOnsSelected: [],
    };
    commit("resetAUDataFlow", data);
  },
  updateFlowPayloadToStateAction({ commit, dispatch }, payload) {
    commit("updateFlowPayloadToState", payload);
    dispatch("getCartDataFromApi");
  },
  resetOrderAction({ commit }) {
    Cookies.remove("orderId");
    commit("resetOrder");
  },
  setNeedAccountingRemediationAction({ commit, dispatch }, payload) {
    commit("setNeedAccountingRemediation", payload);
    dispatch("getCartDataFromApi");
  },
  setSelectedFinancialYearsAction({ commit, dispatch }, payload) {
    commit("setSelectedFinancialYears", payload);
    dispatch("getCartDataFromApi");
  },
  setNumberOfRemediationYearsAction({ commit, dispatch }, payload) {
    commit("setNumberOfRemediationYears", payload);
    dispatch("getCartDataFromApi");
  },
  setUtmQueryAction({ commit }, payload) {
    commit("setUtmQuery", payload);
  },
  setListRemoveProductAction({ commit, dispatch }, payload) {
    commit("setListRemoveProduct", payload);
    dispatch("getCartDataFromApi");
  },
  setListAddProductAction({ commit }, payload) {
    commit("setListAddProduct", payload);
  },
  setNeedCompanySecretaryRemediationAction({ commit, dispatch }, payload) {
    commit("setNeedCompanySecretaryRemediation", payload);
    dispatch("getCartDataFromApi");
  },
  setNumberOfRemediationCompanySecretaryAction({ commit, dispatch }, payload) {
    commit("setNumberOfRemediationCompanySecretary", payload);
    dispatch("getCartDataFromApi");
  },
  setNeedAuditRemediationAction({ commit, dispatch }, payload) {
    commit("setNeedAuditRemediation", payload);
    dispatch("getCartDataFromApi");
  },
  setNumberOfRemediationAuditAction({ commit, dispatch }, payload) {
    commit("setNumberOfRemediationAudit", payload);
    dispatch("getCartDataFromApi");
  },
  setReconfirmAccountingAction({ commit, dispatch }, payload) {
    commit("setReconfirmAccounting", payload);
    dispatch("getCartDataFromApi");
  },
};

const mutations = {
  setOrder(state, payload) {
    state.order = payload;
  },
  setPointOfContact(state, payload) {
    state.pointOfContact = payload;
  },
  setSuffix(state, payload) {
    state.suffix = payload;
  },
  setCurrentPage(state, payload) {
    state.currentPage = payload;
  },
  setBundleConfiguration(state, payload) {
    state.pageServices = payload.pageServices;
    state.flowServices = payload.flowServices;
    state.bundleId = payload.bundleId;
    state.name = payload.name;
  },
  setPageServices(state, payload) {
    state.pageServices = payload;
  },
  setCompanyName(state, payload) {
    state.companyName = payload;
  },
  setNumberOfShareholder(state, payload) {
    state.numberOfShareholder = payload;
  },
  setNeedCorpSec(state, payload) {
    state.needCorpSec = payload;
  },
  setCorpsecPlan(state, payload) {
    state.corpsecPlan = payload;
  },
  setHasNomineeDirector(state, payload) {
    state.hasNomineeDirector = payload;
  },
  setNomineeDirectorTerm(state, payload) {
    state.nomineeDirectorTerm = payload;
  },
  setHasCorporateShareholder(state, payload) {
    state.hasCorporateShareholder = payload;
  },
  setCartData(state, payload) {
    state.cartData = payload;
  },
  setCartLoading(state, payload) {
    state.isCartLoading = payload;
  },
  setPaymentType(state, payload) {
    state.paymentType = payload;
  },
  setAllowSleekToStayInTouch(state, payload) {
    state.isAllowSleekToStayInTouch = payload;
  },
  setContactDetails(state, payload) {
    state.contactDetails = payload;
  },
  setCoupon(state, payload) {
    state.coupon = payload;
  },
  setCouponArray(state, payload) {
    state.couponArray = payload;
  },
  setHasMailroom(state, payload) {
    state.hasMailroom = payload;
  },
  setCompanyCreatedId(state, payload) {
    state.companyCreatedId = payload;
  },
  setInvoice(state, payload) {
    state.invoice = payload;
  },
  setAccountingExpense(state, payload) {
    // state.accountingExpense = payload;
    Vue.set(state, "accountingExpense", payload);
  },
  setAccountingTier(state, payload) {
    state.accountingTier = payload;
  },
  setAccountingSubscriptionType(state, payload) {
    state.accountingSubscriptionType = payload;
  },
  setNeedAccounting(state, payload) {
    state.needAccounting = payload;
  },
  setAccountingAddons(state, payload) {
    state.accountingAddons = payload;
  },
  setInputtedAverageMonthlyExpense(state, payload) {
    state.inputtedAverageMonthlyExpense = payload;
  },
  setHasAuditAndTaxPlan(state, payload) {
    state.hasAuditAndTaxPlan = payload;
  },
  setHasComplexAssetsAudit(state, payload) {
    state.hasComplexAssetsAudit = payload;
  },
  setAuditAndTaxExpense(state, payload) {
    state.auditAndTaxExpense = payload;
  },
  resetState(state) {
    // eslint-disable-next-line no-unused-vars
    state = initialState;
  },
  setCheckoutItems(state, payload) {
    state.checkoutItems = payload;
  },
  setDesiredCompanyName(state, payload) {
    state.desiredCompanyName = payload;
  },
  setSaveForLater(state, payload) {
    state.saveForLater = payload;
  },
  setResumeOnboarding(state, payload) {
    state.numberOfShareholder = payload.numberOfShareholder;
    state.needCorpSec = payload.needCorpSec;
    state.hasCorporateShareholder = payload.hasCorporateShareholder;
    state.hasMailroom = payload.hasMailroom;
    state.accountingSubscriptionType = payload.accountingSubscriptionType;
    state.accountingAddons = payload.accountingAddons;
    state.bundleId = payload.bundleId;
    // state.coupon = payload.coupon;
    state.accountingExpense = payload.accountingExpense;
    state.accountingTier = payload.accountingTier;
    state.needAccounting = payload.needAccounting;
    state.inputtedAverageMonthlyExpense = payload.inputtedAverageMonthlyExpense;
    state.hasAuditAndTaxPlan = payload.hasAuditAndTaxPlan;
    state.hasComplexAssetsAudit = payload.hasComplexAssetsAudit;
    state.auditAndTaxExpense = payload.auditAndTaxExpense;
    state.needVisaConsultation = payload.needVisaConsultation;
    state.hasVisaSupport = payload.hasVisaSupport;
    state.numberOfLetterOfConsent = payload.numberOfLetterOfConsent;
    state.numberOfApplicationPass = payload.numberOfApplicationPass;
    state.hasNomineeDirector = payload.hasNomineeDirector;
    state.nomineeDirectorTerm = payload.nomineeDirectorTerm;

    // AU
    state.hasASICCompliance = payload.hasASICCompliance;
    state.hasABNTaxCompliance = payload.hasABNTaxCompliance;
    state.addOnsSelected = payload.addOnsSelected;
  },

  // immigration
  setNeedVisaConsultation(state, payload) {
    state.needVisaConsultation = payload;
  },
  setHasVisaSupport(state, payload) {
    state.hasVisaSupport = payload;
  },
  setNumberOfLetterOfConsent(state, payload) {
    state.numberOfLetterOfConsent = payload;
  },
  setNumberOfApplicationPass(state, payload) {
    state.numberOfApplicationPass = payload;
  },
  setManageFinancial(state, payload) {
    state.manageFinancial = payload;
  },
  setFinancialNotSureOption(state, payload) {
    state.financialNotSureOption = payload;
  },
  setShowAccountingUI(state, payload) {
    state.showAccountingUI = payload;
  },
  setNeedGuidancePopup(state, payload) {
    state.needGuidancePopup = payload;
  },
  setSBAIsInterested(state, payload) {
    state.sbaIsInterested = payload;
  },
  setPopupTimeout(state, payload) {
    state.popupTimeout = payload;
  },
  setInitialValues(state, payload) {
    if (payload && state.isSetInitialValues === false) {
      state.isSetInitialValues = true;
      state = Object.assign(state, payload);
      if (typeof payload.accountingExpense == "undefined") {
        state.accountingExpense = undefined;
      }
    }
  },
  setUtmQuery(state, payload) {
    state = Object.assign(state, payload);
  },
  setHasASICCompliance(state, payload) {
    state.hasASICCompliance = payload;
  },
  setHasABNTaxCompliance(state, payload) {
    state.hasABNTaxCompliance = payload;
  },
  setShowComparePlanPopup(state, payload) {
    state.showComparePlanPopup = payload;
  },
  setAddOnsSelected(state, payload) {
    state.addOnsSelected = payload;
  },
  setIsDormantFlow(state, payload) {
    state.isDormantFlow = payload;
  },
  setIsSoleTraderFlow(state, payload) {
    state.isSoleTraderFlow = payload;
  },
  setCurrentBundleTransferId(state, payload) {
    state.currentFlowId[payload.flowName] = payload.bundleId;
  },
  setCurrentFlowPayload(state, payload) {
    state.currentFlowPayload[payload.flowName] = payload.data;
  },
  updateFlowPayloadToState(state, payload) {
    state = Object.assign(state, state.currentFlowPayload?.[payload]);
  },
  setAccountingOptionDisable(state, payload) {
    state.accountingOptionDisable = payload;
  },
  resetAUDataFlow(state, payload) {
    state.isSetInitialValues = false;
    state = Object.assign(state, payload);
  },
  setCollapsedColC(state, payload) {
    state.collapsedColC = payload;
  },
  resetOrder(state) {
    state.order = null;
  },
  setNeedAccountingRemediation(state, payload) {
    // state.needAccountingRemediation = payload;
    Vue.set(state, "needAccountingRemediation", payload);
    if (!payload) {
      state.selectedFinancialYears = [];
      state.numberOfRemediationYears = 0;
    }
  },
  setSelectedFinancialYears(state, payload) {
    state.selectedFinancialYears = payload;
  },
  setNumberOfRemediationYears(state, payload) {
    state.numberOfRemediationYears = payload;
  },
  setListRemoveProduct(state, payload) {
    state.listRemoveProduct = payload;
  },
  setListAddProduct(state, payload) {
    state.listAddProduct = payload;
  },
  setNeedCompanySecretaryRemediation(state, payload) {
    Vue.set(state, "needCompanySecretaryRemediation", payload);
    // state.needCompanySecretaryRemediation = payload;
    if (!payload) {
      state.numberOfRemediationCompanySecretary = 0;
    }
  },
  setNumberOfRemediationCompanySecretary(state, payload) {
    state.numberOfRemediationCompanySecretary = payload;
  },
  setNeedAuditRemediation(state, payload) {
    Vue.set(state, "needAuditRemediation", payload);
    // state.needAuditRemediation = payload;
    if (!payload) {
      state.numberOfRemediationAudit = 0;
    }
  },
  setNumberOfRemediationAudit(state, payload) {
    state.numberOfRemediationAudit = payload;
  },
  setReconfirmAccounting(state, payload) {
    state.reconfirmAccounting = payload;
  },
  setIsFirstShowBanner(state, payload) {
    state.isFirstShowBanner = payload;
  },
  setCouponEligible(state, payload) {
    state.couponEligible = payload;
  },
  setIsBilledYearly(state, payload) {
    state.isBilledYearly = payload;
  },
  setIsCheckoutPage(state, payload) {
    state.isCheckoutPage = payload;
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
